export var LocalStorageEnums;
(function (LocalStorageEnums) {
    LocalStorageEnums["LOCALE"] = "locale";
})(LocalStorageEnums || (LocalStorageEnums = {}));
